import { Link } from 'react-router-dom';

const projects = [
  {
    title: 'Modern Kitchen Transformation',
    category: 'Kitchen Remodeling',
    description: 'Complete kitchen overhaul with custom cabinetry, quartz countertops, and an open-concept layout.',
    image: '/images/Modern-Kitchen-Transformation.webp',
  },
  {
    title: 'Luxury Bathroom Renovation',
    category: 'Bathroom Remodeling',
    description: 'Spa-inspired master bathroom with walk-in shower, freestanding tub, and heated floors.',
    image: '/images/Luxury-Bathroom-Renovation.webp',
  },
  {
    title: 'Complete Home Renovation',
    category: 'General Contracting',
    description: 'Full home renovation including structural updates, new flooring, and modern finishes throughout.',
    image: '/images/Complete-Home-Renovation.webp',
  },
];

export default function ProjectGallery() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start gap-8 mb-12 md:mb-16">
          <div className="lg:w-2/5">
            <span className="inline-block text-xs md:text-sm font-medium tracking-wider uppercase text-accent-600 mb-3">
              Our Work
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              Featured <span className="text-primary-500">Projects</span>
            </h2>
          </div>
          <div className="lg:w-3/5">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              Every project tells a story of transformation. Browse through our recent work to see the quality and attention to detail we bring to every job — from small upgrades to complete renovations.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          {projects.map((project, idx) => (
            <div
              key={project.title}
              className={`group rounded-xl overflow-hidden border border-background-200/60 cursor-pointer transition-all ${
                idx === 0 ? 'lg:col-span-1' : ''
              }`}
            >
              <div className="relative overflow-hidden" style={{ height: idx === 0 ? '360px' : '280px' }}>
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                {/* Logo watermark */}
                <div className="absolute inset-0 pointer-events-none flex items-center justify-center">
                  <img
  src="/images/LOGO-RAFAEL.webp"
  alt=""
  aria-hidden="true"
  className="w-[45%] max-w-[200px] opacity-[0.12]"
  loading="lazy"
/>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-3 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-xs font-medium text-primary-600">
                    {project.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                  {project.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {project.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/projects"
            className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-semibold hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
          >
            View Full Gallery
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}